import { mobileMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Label = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.textDark};
  margin-right: 10px;

  @media (${mobileMax}) {
    margin-bottom: 20px;
  }
`;

export const Container = styled.div<{ direction?: string }>`
  display: flex;
  flex: 1;

  ${(props) =>
    props.direction === 'row'
      ? `
    flex-direction: row;
    align-items: center;
  `
      : `
    flex-direction: column;
  `}

  @media (${mobileMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const BarBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 56px;
`;

export const BackgroundBar = styled.div<{ disabled?: boolean }>`
  position: relative;
  display: flex;
  flex: 1;
  background: ${(props) => props.theme.backgroundLightest};
  border-radius: 8px;
  height: 12px;
  margin: 20px 0;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const FillerBar = styled.div`
  background: ${(props) => props.theme.primary};
  border-radius: 12px;
  width: 100%;
  height: 12px;
`;

export const Handle = styled.div`
  background-color: ${(props) => props.theme.textLight};
  width: 80px;
  height: 35px;
  position: absolute;
  top: -12px;
  border-radius: 18px;
  cursor: pointer;
`;

export const HandleText = styled.p`
  color: ${(props) => props.theme.white};
  font-size: 14px;
  text-align: center;
  margin-top: 6px;
  user-select: none;
`;
